import {SceProviderConfig} from "./config/sceProviderConfig";
import {MAIN_CONTROLLER} from "./controller/MainController";
import {NavigationComponent} from "./components/navigation/navigationComponent";
import {PROFILE_COMPONENT} from "./components/profile/profileComponent";
import {MATERIAL_THEMMING_PROVIDER} from "./config/materialThemingProvider";
import {MainModuleConfiguration} from "./MainModuleConfiguration";
import {IHttpProvider} from "angular";
import {global_403_handler_factory} from "./factory/global_40e_handler";
import {PageTitleServiceName} from "../utils/names/serviceNames";
import {PageTitleService} from "./service/page-title.service";

import './main.scss';

MainModuleConfiguration
    .createNewModule()
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.defaults.withCredentials = true;
    }])
    .component('userProfile', PROFILE_COMPONENT)
    .config(['$sceProvider', SceProviderConfig])
    .component('navigationComponent', NavigationComponent.instance)
    .config(MATERIAL_THEMMING_PROVIDER)
    .controller('mainController', MAIN_CONTROLLER)
    .factory('global_403_handler', [global_403_handler_factory])
    .config(['$httpProvider', function ($httpProvider: IHttpProvider) {
        $httpProvider.interceptors.push('global_403_handler')
    }])
    .service(PageTitleServiceName, PageTitleService.instance)
    .config(['$compileProvider', function ($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
    }]);